module.exports = __webpack_public_path__ + "static/media/use_esim_en2.6f968fad.png";